module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.114fab91.svg";